import HeroBanner from '../HeroBanner';
import ValueProposition from './ValueProposition';

const slides = [
  {
    image: '/images/home-hero-banners/slide-1.svg',
    imageMobile: '/images/home-hero-banners/slide-1-mobile.svg',
    content: (
      <>
        <h1 className="md:text-4xl font-bold">
          Keep your meals perfectly fresh
        </h1>
        <p className="text-sm mt-2">
          Own it with your terms, pay up to 6 months
        </p>
        <a
          href="/electronics/Home%20Appliances/6808c548ce3d87d45c32/hisense-529l-refrigerator-2855"
          className="bg-white text-[#564775] md:py-2 py-1 px-3 md:px-6 my-4 w-fit rounded-xl"
        >
          Get it now
        </a>
      </>
    ),
  },
  {
    image: '/images/home-hero-banners/slide-2.svg',
    imageMobile: '/images/home-hero-banners/slide-2-mobile.svg',
    content: (
      <>
        <h1 className="md:text-4xl font-bold ">Boost your productivity</h1>
        <p className="text-sm mt-2">
          Own a Macbook pro now & pay up to 6 months
        </p>
        <a
          href="/electronics/Home%20Appliances/66f3461f0306b9ddc25e/13-macbook-air-m1256gb8gb-65"
          className="bg-white text-[#FEC310] md:py-2 py-1 px-3 md:px-6 my-4 w-fit rounded-xl"
        >
          Get it now
        </a>
      </>
    ),
  },
  /*
  {
    // image: '/images/home-hero-banners/slide-8.svg',
    // imageMobile: '/images/home-hero-banners/slide-8-mobile.svg',
    content: (
      <>
       <h1 className="text-3xl font-bold">Slide Two</h1>
        <p className="text-sm mt-2">Explore electronics & more</p>
      </>
    ),
  },*/
];

export const HomeHeroBanner = () => {
  const categoriesBanner = false;
  return (
    <>
      <HeroBanner
        slides={slides}
        autoSlideInterval={3000}
        height={360}
        categoriesBanner={categoriesBanner}
      />

      <ValueProposition />
    </>
  );
};
